import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { ButtonBase } from "./ButtonBase";
import { Svg } from "./Svg";
import { useTheme } from "./ThemeProvider";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { useUncontrolledAndControlled, } from "../system/utils/uncontrolled-and-controlled";
export const switchSizeOptions = ["small", "large"];
export const switchClasses = {
    disabled: "MinervaSwitch-disabled",
    small: "MinervaSwitch-small",
    large: "MinervaSwitch-large",
    thumb: "MinervaSwitch-thumb",
};
export const Switch = (props) => {
    const { size = "small", disabled, defaultSwitched = false, switched, onSwitchChange, color: _color = "surface", colorSet, invertColors, sx, className, ...rest } = useDefaultProps({ props, component: "Switch" });
    const { internalValue: internalSwitched, handleValueChange: handleSwitchChange } = useUncontrolledAndControlled({
        defaultValue: defaultSwitched,
        value: switched,
        onValueChange: onSwitchChange,
    });
    const theme = useTheme();
    const sizing = {
        large: 5,
        small: 3,
    };
    return (_jsx(ColorsProvider, { color: _color, colorSet: colorSet, invertColors: invertColors ? invertColors : !internalSwitched, children: ({ color, background }) => (_jsx(ButtonBase, { disableHoverEffect: true, disableActiveEffect: true, disabled: disabled, onClick: () => handleSwitchChange(!internalSwitched), className: clsx([
                disabled && switchClasses.disabled,
                switchClasses[size],
                className,
            ]), sx: mergeSx({
                display: "flex",
                alignItems: "center",
                justifyContent: internalSwitched ? "end" : "start",
                backgroundColor: background,
                borderRadius: theme.radius.full,
                border: "2px solid",
                borderColor: `${_color !== "inherit" ? theme.palette[_color].main : "inherit"}`,
                transition: "background-color 300ms ease",
                [`&.${switchClasses.small}`]: {
                    width: 9,
                    height: 5,
                    padding: 0.5,
                },
                [`&.${switchClasses.large}`]: {
                    width: 11,
                    height: 6.5,
                    padding: internalSwitched ? 0.25 : 0.75,
                },
                [`&.${switchClasses.disabled}`]: {
                    backgroundColor: internalSwitched
                        ? theme.palette.disabled.main
                        : theme.palette.disabled.onMain,
                    border: `2px solid ${theme.palette.disabled.main}`,
                },
            }, sx), ...rest, 
            //for ARIA - Accesibilty
            type: "button", role: "switch", "aria-checked": internalSwitched, "aria-label": "Switch", children: _jsx(Svg, { width: size === "large" && !internalSwitched ? 4 : sizing[size], height: size === "large" && !internalSwitched ? 4 : sizing[size], viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg", fill: "none", className: clsx([switchClasses.thumb, className]), children: _jsx("circle", { cx: 25, cy: 25, r: 25, fill: disabled
                        ? internalSwitched
                            ? theme.palette.disabled.onMain
                            : theme.palette.disabled.main
                        : color }) }) })) }));
};
//# sourceMappingURL=Switch.js.map